module.exports = __webpack_public_path__ + "static/pic02-c292fe4318b5f19067c5127af3350cf0.jpg";